function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 27.25C16 27.25 12.75 24 12.75 20C12.75 16 16 12.75 20 12.75C24 12.75 27.25 16 27.25 20C27.25 24 24 27.25 20 27.25ZM20 14.25C16.83 14.25 14.25 16.83 14.25 20C14.25 23.17 16.83 25.75 20 25.75C23.17 25.75 25.75 23.17 25.75 20C25.75 16.83 23.17 14.25 20 14.25Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 30.96C19.45 30.96 19 30.55 19 30V29.92C19 29.37 19.45 28.92 20 28.92C20.55 28.92 21 29.37 21 29.92C21 30.47 20.55 30.96 20 30.96ZM27.14 28.14C26.88 28.14 26.63 28.04 26.43 27.85L26.3 27.72C25.91 27.33 25.91 26.7 26.3 26.31C26.69 25.92 27.32 25.92 27.71 26.31L27.84 26.44C28.23 26.83 28.23 27.46 27.84 27.85C27.65 28.04 27.4 28.14 27.14 28.14ZM12.86 28.14C12.6 28.14 12.35 28.04 12.15 27.85C11.76 27.46 11.76 26.83 12.15 26.44L12.28 26.31C12.67 25.92 13.3 25.92 13.69 26.31C14.08 26.7 14.08 27.33 13.69 27.72L13.56 27.85C13.37 28.04 13.11 28.14 12.86 28.14ZM30 21H29.92C29.37 21 28.92 20.55 28.92 20C28.92 19.45 29.37 19 29.92 19C30.47 19 30.96 19.45 30.96 20C30.96 20.55 30.55 21 30 21ZM10.08 21H10C9.45 21 9 20.55 9 20C9 19.45 9.45 19 10 19C10.55 19 11.04 19.45 11.04 20C11.04 20.55 10.63 21 10.08 21ZM27.01 13.99C26.75 13.99 26.5 13.89 26.3 13.7C25.91 13.31 25.91 12.68 26.3 12.29L26.43 12.16C26.82 11.77 27.45 11.77 27.84 12.16C28.23 12.55 28.23 13.18 27.84 13.57L27.71 13.7C27.52 13.89 27.27 13.99 27.01 13.99ZM12.99 13.99C12.73 13.99 12.48 13.89 12.28 13.7L12.15 13.56C11.76 13.17 11.76 12.54 12.15 12.15C12.54 11.76 13.17 11.76 13.56 12.15L13.69 12.28C14.08 12.67 14.08 13.3 13.69 13.69C13.5 13.89 13.24 13.99 12.99 13.99ZM20 11.04C19.45 11.04 19 10.63 19 10.08V10C19 9.45 19.45 9 20 9C20.55 9 21 9.45 21 10C21 10.55 20.55 11.04 20 11.04Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunLight);
export default __webpack_public_path__ + "static/media/sun-light.c1e66712cea7243f506fa850044402ef.svg";
export { ForwardRef as ReactComponent };